var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.25 3.0625L7 7.875L1.75 3.0625H12.25Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.625H1.75C1.63397 2.625 1.52269 2.67109 1.44064 2.75314C1.35859 2.83519 1.3125 2.94647 1.3125 3.0625V10.5C1.3125 10.7321 1.40469 10.9546 1.56878 11.1187C1.73288 11.2828 1.95544 11.375 2.1875 11.375H11.8125C12.0446 11.375 12.2671 11.2828 12.4312 11.1187C12.5953 10.9546 12.6875 10.7321 12.6875 10.5V3.0625C12.6875 2.94647 12.6414 2.83519 12.5594 2.75314C12.4773 2.67109 12.366 2.625 12.25 2.625ZM7 7.28164L2.87492 3.5H11.1251L7 7.28164ZM5.3982 7L2.1875 9.94273V4.05727L5.3982 7ZM6.0457 7.59336L6.70195 8.19766C6.78267 8.27175 6.88825 8.31286 6.99781 8.31286C7.10738 8.31286 7.21296 8.27175 7.29367 8.19766L7.94992 7.59336L11.1218 10.5H2.87492L6.0457 7.59336ZM8.6018 7L11.8125 4.05672V9.94328L8.6018 7Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingEmail);
export default __webpack_public_path__ + "static/media/marketing-email.9be63721a08121e58250260ddf178d4b.svg";
export { ForwardRef as ReactComponent };